module.exports = __webpack_public_path__ + "img/icon-state-critical.954b3d82.svg";